export default __webpack_public_path__ + "static/media/marbleafter.342e9153.jpg";